export enum EColorPalette {
  danger = '#d00000',
  dark = '#4f4f4f',
  default = '#aaaaa9',
  primary = '#041f74',
  success = '#7ed321;',
  warning = '#f9b000',
  white = '#fff',
  transparent = 'transparent',
}
export type TIconColor =
  | 'danger'
  | 'dark'
  | 'grey'
  | 'default'
  | 'primary'
  | 'success'
  | 'warning'
  | 'white'
  | 'transparent';
export type TSkin = 'default' | 'secondary' | 'custom';
export type TTheme = 'light' | 'dark';
export type TProgressColor = 'primary' | 'danger' | 'warning' | 'success';
export type TProgressBackgroundColor = 'dark' | 'transparent';
